import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/ynweb_logo.svg'
import _imports_1 from '@/assets/images/ynweb_copy.svg'


const _hoisted_1 = { class: "l-header" }
const _hoisted_2 = { class: "l-header__inner" }
const _hoisted_3 = { class: "l-header-logo" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "-Logo",
  src: _imports_0,
  alt: "夢ナビ",
  loading: "lazy"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "header_copy u-pcOnly" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "-Catch",
    src: _imports_1,
    alt: "大学で究める学問発見サイト 夢ナビ",
    loading: "lazy"
  })
], -1)
const _hoisted_8 = { class: "c-hamburgerMenu" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "horizontalLine" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "horizontalLine" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "horizontalLine" }, null, -1)
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<li class=\"-HamburgerCategory\">講義を探す</li><li><a href=\"./result.html?Kw=\">関心ワードから探す</a></li><li><a href=\"./result.html?Dg=\">大学名から探す</a></li><li><a href=\"./result.html?Gb=\">学部・学科名から探す</a></li><li><a href=\"./result.html?Kj=\">先生名から探す</a></li>", 5)
const _hoisted_20 = { class: "pc" }
const _hoisted_21 = ["href"]
const _hoisted_22 = ["href"]
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "sp" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("li", { class: "-HamburgerCategory" }, "オススメ講義", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "./result.html?New=true&SerKbn=n" }, "新着講義")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("li", { class: "-HamburgerCategory" }, "その他", -1)
const _hoisted_31 = ["href"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "horizontalLine" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "horizontalLine" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "horizontalLine" }, null, -1)
const _hoisted_35 = [
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createElementVNode("a", {
          href: `${_ctx.consts.yumenaviinfo}`
        }, _hoisted_6, 8, _hoisted_4),
        _hoisted_7
      ]),
      _createElementVNode("div", {
        id: "c-hamburgerWrapper",
        class: _normalizeClass({ 'js-navOpen': _ctx.isNavOpen })
      }, [
        _createElementVNode("nav", _hoisted_8, [
          _createElementVNode("button", {
            class: "c-hamburgerClose",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickMenuToggle && _ctx.onClickMenuToggle(...args))),
            "aria-label": "メニュー閉じるボタン"
          }, _hoisted_12),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: `${_ctx.consts.yumenaviinfo}`
              }, "TOP", 8, _hoisted_13)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", { href: `./howto.html` }, "夢ナビとは", 8, _hoisted_14)
            ]),
            _hoisted_15,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("li", null, [
                _createElementVNode("a", { href: `../gakumon.aspx` }, "学問分野から探す", 8, _hoisted_21)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", { href: `../category_pc.aspx` }, "“カテゴリー別”関心ワードから探す", 8, _hoisted_22)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", { href: `../on50_pc.aspx` }, "“50音別”関心ワードから探す", 8, _hoisted_23)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("li", null, [
                _createElementVNode("a", { href: `../gakumon_sp.aspx` }, "学問分野から探す", 8, _hoisted_25)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", { href: `../category_sp.aspx` }, "“カテゴリー別”関心ワードから探す", 8, _hoisted_26)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", { href: `../on50_sp.aspx` }, "“50音別”関心ワードから探す", 8, _hoisted_27)
              ])
            ]),
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: `https://frompage.jp/douga/pr/`,
                target: "_blank",
                rel: "noopener noreferrer"
              }, "夢ナビ講義動画サービスのご案内", 8, _hoisted_31)
            ])
          ])
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(["c-hamburger", { 'js-active': _ctx.isNavOpen }]),
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickMenuToggle && _ctx.onClickMenuToggle(...args))),
          "aria-label": "メニューボタン"
        }, _hoisted_35, 2)
      ], 2)
    ])
  ]))
}